
import { MobileNavbar } from './mobile';
import { PCNavbar } from './PC';
import { LinkHref } from './config';

interface IProps {
  initType?: 'transparent' | 'white';
  mobile?: 'transparent' | 'white';
  pc?: 'transparent' | 'white';
  cssBox?: string;
  boxStyle?: React.CSSProperties;
  isDetail?: boolean;
  title?: string;
  isAdmin?: boolean;
}
export const Navbar = ({
  initType = 'white',
  mobile,
  pc,
  ...otherProps
}: IProps) => {
  return (
    <>
      <PCNavbar type={pc ?? initType} {...otherProps} />
      <MobileNavbar initType={mobile ?? initType} />
    </>
  );
};

export { LinkHref };
